<template>
    <div class="">
        <!-- Talleres de Aula Orsai -->
        <div v-if="!loading && !error && talleres.length > 0">
            <!-- Filtros -->
            <div v-if="talleresActivos.length > 0"
                class="flex justify-between items-start md:items-center md:mb-8 flex-col md:flex-row">
                <div></div>
            </div>

            <!-- Overlay para cerrar menús -->
            <div v-if="openSubMenu" class="fixed inset-0 z-40" @click="closeAllMenus"></div>

            <!-- Sección de Talleres Virtuales (PRIMERO) -->
            <section v-if="talleresVirtualesActivos.length > 0" class="mb-16">
                <div class="text-left mb-8">
                    <h2
                        class="font-inter font-bold text-[24px] leading-[120%] tracking-[0%] md:text-[32px] md:leading-[120%] mb-4">
                        Talleres Virtuales
                    </h2>
                    <p class="text-gray-600 text-[16px] md:text-[18px] leading-relaxed">
                        Clases en tiempo real, con interacción, devoluciones y actividades semanales.
                        Cupo limitado. Desde cualquier parte del mundo.
                    </p>
                </div>

                <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-8">
                    <div v-for="taller in talleresVirtualesActivos" :key="taller.id"
                        class="post-item max-w-md w-full mx-auto">
                        <!-- Desktop/Tablet view -->
                        <div
                            class="bg-white rounded-2xl shadow-md border border-gray-200 flex flex-col hidden md:block h-full">
                            <a :href="taller.linkTienda" target="_blank"
                                class="block w-full aspect-square overflow-hidden rounded-t-2xl">
                                <template v-if="taller.urlAfiche">
                                    <img :src="taller.urlAfiche" :alt="taller.lema"
                                        class="w-full h-full object-cover rounded-t-2xl" @error="handleImageError" />
                                </template>
                                <div v-else
                                    class="w-full aspect-square bg-gray-100 flex items-center justify-center rounded-t-2xl">
                                    <span class="text-gray-400">Sin imagen</span>
                                </div>
                            </a>
                            <div class="flex flex-col flex-grow px-4 pt-2">
                                <!-- Título del taller -->
                                <h3 class="text-base font-bold leading-tight text-black pt-2">
                                    {{ taller.id === 285891222 ? 'Guion cinematográfico' : taller.lema }}
                                </h3>
                                <!-- Docente -->
                                <p class="text-sm font-normal leading-tight text-gray-600">{{ taller.docente }}</p>

                                <!-- Precio -->
                                <div class="pt-2">
                                    <div v-if="taller.tieneDescuento" class="flex items-center gap-2">
                                        <span class="text-md font-bold text-green-600">ARS {{ taller.precio }}</span>
                                        <span class="text-sm text-red-500 line-through">ARS {{ taller.precioOriginal
                                            }}</span>
                                    </div>
                                    <div v-else>
                                        <span class="text-md font-bold text-gray-900">ARS {{ taller.precio }}</span>
                                    </div>
                                    <span v-if="taller.precioUSD" class="text-sm text-gray-500 block">USD {{
                                        taller.precioUSD }}</span>
                                </div>
                            </div>

                            <!-- Botones -->
                            <div class="px-4 pb-4 mt-4">
                                <div class="flex flex-col gap-2">
                                    <!-- Botón principal: Reservar -->
                                    <a :href="taller.linkTienda" target="_blank"
                                        class="text-white text-sm font-semibold leading-none text-center py-3 px-4 rounded-lg uppercase transition-colors w-full mt-2"
                                        :style="taller.colorBoton ? { backgroundColor: taller.colorBoton } : { backgroundColor: '#2563eb' }"
                                        @click="trackReservarClick(taller, 'taller-virtual')">
                                        {{ taller.boton }}
                                    </a>
                                </div>
                            </div>
                        </div>

                        <!-- Mobile view -->
                        <div class="bg-white rounded-2xl shadow-md border border-gray-200 flex flex-row md:hidden">
                            <!-- Imagen del taller (mobile) -->
                            <a :href="taller.linkTienda" target="_blank"
                                class="block w-1/2 aspect-square overflow-hidden rounded-l-2xl">
                                <template v-if="taller.urlAfiche">
                                    <img :src="taller.urlAfiche" :alt="taller.lema"
                                        class="w-full h-full object-cover rounded-l-2xl" @error="handleImageError" />
                                </template>
                                <div v-else
                                    class="w-full aspect-square bg-gray-100 flex items-center justify-center rounded-l-2xl">
                                    <span class="text-gray-400">Sin imagen</span>
                                </div>
                            </a>
                            <!-- Contenido del taller (mobile) -->
                            <div class="flex flex-col justify-between p-4 w-1/2">
                                <div>
                                    <!-- Título del taller (mobile) -->
                                    <h3 class="text-base font-bold leading-[120%] text-black mt-1">
                                        {{ taller.id === 285891222 ? 'Guion cinematográfico' : taller.lema }}
                                    </h3>
                                    <!-- Docente (mobile) -->
                                    <p class="text-[10px] font-normal leading-[130%] text-gray-600 uppercase mt-1">{{
                                        taller.docente }}</p>
                                </div>
                                <div class="mt-auto">
                                    <!-- Precio ARS (mobile) -->
                                    <div class="mb-3">
                                        <div v-if="taller.tieneDescuento" class="flex items-center gap-2">
                                            <span class="text-sm font-bold text-green-600">ARS {{ taller.precio
                                                }}</span>
                                            <span class="text-xs text-red-500 line-through">ARS {{ taller.precioOriginal
                                                }}</span>
                                        </div>
                                        <div v-else>
                                            <span class="text-sm font-bold text-gray-900 block">ARS {{ taller.precio
                                                }}</span>
                                        </div>
                                        <span v-if="taller.precioUSD" class="text-xs text-gray-500 block">USD {{
                                            taller.precioUSD }}</span>
                                    </div>
                                    <!-- Botón principal: Reservar (mobile) -->
                                    <a :href="taller.linkTienda" target="_blank"
                                        class="text-white text-[10px] font-semibold leading-[140%] text-center py-2 px-4 rounded-md uppercase transition-colors w-full block mb-2 mt-2"
                                        :style="taller.colorBoton ? { backgroundColor: taller.colorBoton } : { backgroundColor: '#2563eb' }"
                                        @click="trackReservarClick(taller, 'taller-virtual')">
                                        {{ taller.boton }}
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <!-- Sección de Campamentos (SEGUNDO) -->
            <section v-if="campamentosActivos.length > 0" class="mb-16">
                <div class="mb-8">
                    <h2
                        class="font-inter font-bold text-[24px] leading-[120%] tracking-[0%] md:text-[32px] md:leading-[120%] mb-4">
                        Campamentos de Escritura
                    </h2>
                    <p class="text-gray-600 text-[16px] md:text-[18px] leading-relaxed">
                        Una semana completa de escritura intensiva junto a autores y autoras.
                        Modo presencial en el espacio Orsai en Sala Casals.
                    </p>
                </div>

                <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-8">
                    <div v-for="taller in campamentosActivos" :key="taller.id"
                        class="post-item max-w-md w-full mx-auto">
                        <!-- Desktop/Tablet view -->
                        <div
                            class="bg-white rounded-2xl shadow-md border border-gray-200 flex flex-col hidden md:block h-full">
                            <a :href="taller.linkTienda" target="_blank"
                                class="block w-full aspect-square overflow-hidden rounded-t-2xl">
                                <template v-if="taller.urlAfiche">
                                    <img :src="taller.urlAfiche" :alt="taller.lema"
                                        class="w-full h-full object-cover rounded-t-2xl" @error="handleImageError" />
                                </template>
                                <div v-else
                                    class="w-full aspect-square bg-gray-100 flex items-center justify-center rounded-t-2xl">
                                    <span class="text-gray-400">Sin imagen</span>
                                </div>
                            </a>
                            <div class="flex flex-col flex-grow px-4 pt-2">
                                <div class="flex gap-2">
                                    <!-- Fecha del taller -->
                                    <span class="text-xs font-normal leading-tight uppercase">
                                        Desde el <span class="font-bold">{{ taller.inicio }}</span>
                                    </span>
                                </div>
                                <!-- Título del taller -->
                                <h3 class="text-base font-bold leading-tight text-black pt-2">
                                    {{ taller.id === 285891222 ? 'Guion cinematográfico' : taller.lema }}
                                </h3>
                                <!-- Docente -->
                                <p class="text-sm font-normal leading-tight text-gray-600">{{ taller.docente }}</p>

                                <!-- Precio -->
                                <div class="pt-2">
                                    <div v-if="taller.tieneDescuento" class="flex items-center gap-2">
                                        <span class="text-md font-bold text-green-600">ARS {{ taller.precio }}</span>
                                        <span class="text-sm text-red-500 line-through">ARS {{ taller.precioOriginal
                                            }}</span>
                                    </div>
                                    <div v-else>
                                        <span class="text-md font-bold text-gray-900">ARS {{ taller.precio }}</span>
                                    </div>
                                    <span v-if="taller.precioUSD" class="text-sm text-gray-500 block">USD {{
                                        taller.precioUSD }}</span>
                                </div>
                            </div>

                            <!-- Botones -->
                            <div class="px-4 pb-4 mt-4">
                                <div class="flex flex-col gap-2">
                                    <!-- Botón principal: Reservar -->
                                    <a :href="taller.linkTienda" target="_blank"
                                        class="text-white text-sm font-semibold leading-none text-center py-3 px-4 rounded-lg uppercase transition-colors w-full mt-2"
                                        :style="taller.colorBoton ? { backgroundColor: taller.colorBoton } : { backgroundColor: '#2563eb' }"
                                        @click="trackReservarClick(taller, 'campamento')">
                                        {{ taller.boton }}
                                    </a>
                                </div>
                            </div>
                        </div>

                        <!-- Mobile view -->
                        <div class="bg-white rounded-2xl shadow-md border border-gray-200 flex flex-row md:hidden">
                            <!-- Imagen del taller (mobile) -->
                            <a :href="taller.linkTienda" target="_blank"
                                class="block w-1/2 aspect-square overflow-hidden rounded-l-2xl">
                                <template v-if="taller.urlAfiche">
                                    <img :src="taller.urlAfiche" :alt="taller.lema"
                                        class="w-full h-full object-cover rounded-l-2xl" @error="handleImageError" />
                                </template>
                                <div v-else
                                    class="w-full aspect-square bg-gray-100 flex items-center justify-center rounded-l-2xl">
                                    <span class="text-gray-400">Sin imagen</span>
                                </div>
                            </a>
                            <!-- Contenido del taller (mobile) -->
                            <div class="flex flex-col justify-between p-4 w-1/2">
                                <div>
                                    <!-- Fecha del taller (mobile) -->
                                    <span class="text-[10px] font-normal leading-[130%] uppercase">Desde el <span
                                            class="font-bold">{{
                                                taller.inicio }}</span></span>
                                    <!-- Título del taller (mobile) -->
                                    <h3 class="text-base font-bold leading-[120%] text-black mt-1">
                                        {{ taller.id === 285891222 ? 'Guion cinematográfico' : taller.lema }}
                                    </h3>
                                    <!-- Docente (mobile) -->
                                    <p class="text-[10px] font-normal leading-[130%] text-gray-600 uppercase mt-1">{{
                                        taller.docente }}</p>
                                </div>
                                <div class="mt-auto">
                                    <!-- Precio ARS (mobile) -->
                                    <div class="mb-3">
                                        <div v-if="taller.tieneDescuento" class="flex items-center gap-2">
                                            <span class="text-sm font-bold text-green-600">ARS {{ taller.precio
                                                }}</span>
                                            <span class="text-xs text-red-500 line-through">ARS {{ taller.precioOriginal
                                                }}</span>
                                        </div>
                                        <div v-else>
                                            <span class="text-sm font-bold text-gray-900 block">ARS {{ taller.precio
                                                }}</span>
                                        </div>
                                        <span v-if="taller.precioUSD" class="text-xs text-gray-500 block">USD {{
                                            taller.precioUSD }}</span>
                                    </div>
                                    <!-- Botón principal: Reservar (mobile) -->
                                    <a :href="taller.linkTienda" target="_blank"
                                        class="text-white text-[10px] font-semibold leading-[140%] text-center py-2 px-4 rounded-md uppercase transition-colors w-full block mb-2 mt-2"
                                        :style="taller.colorBoton ? { backgroundColor: taller.colorBoton } : { backgroundColor: '#2563eb' }"
                                        @click="trackReservarClick(taller, 'campamento')">
                                        {{ taller.boton }}
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <!-- Talleres finalizados -->
            <div v-if="talleresFinalizados.length > 0" class="mt-16">
                <div class="flex justify-between items-start md:items-center md:mb-8 flex-col md:flex-row">
                    <h2
                        class="font-inter font-bold text-[16px] leading-[128%] tracking-[0%] md:text-[24px] md:leading-[120%]">
                        Talleres anteriores</h2>
                </div>

                <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-8 mt-4">
                    <div v-for="taller in talleresFinalizados" :key="taller.id"
                        class="post-item max-w-md w-full mx-auto">
                        <!-- Desktop/Tablet view -->
                        <div
                            class="bg-white rounded-2xl shadow-md border border-gray-200 flex flex-col hidden md:block opacity-75 h-full">
                            <a :href="taller.linkTienda" target="_blank"
                                class="block w-full aspect-square overflow-hidden rounded-t-2xl">
                                <template v-if="taller.urlAfiche">
                                    <img :src="taller.urlAfiche" :alt="taller.lema"
                                        class="w-full h-full object-cover rounded-t-2xl" @error="handleImageError" />
                                </template>
                                <div v-else
                                    class="w-full aspect-square bg-gray-100 flex items-center justify-center rounded-t-2xl">
                                    <span class="text-gray-400">Sin imagen</span>
                                </div>
                            </a>
                            <div class="flex gap-2 px-4 pt-2">
                                <!-- Fecha del taller -->
                                <span class="text-xs font-normal leading-tight uppercase">
                                    Desde el <span class="font-bold">{{ taller.inicio }}</span>
                                </span>
                            </div>
                            <!-- Título del taller -->
                            <h3 class="text-base font-bold leading-tight text-black px-4 pt-2">
                                {{ taller.id === 285891222 ? 'Guion cinematográfico' : taller.lema }}
                            </h3>
                            <!-- Docente -->
                            <p class="text-sm font-normal leading-tight text-gray-600 px-4">{{ taller.docente }}</p>

                            <!-- Precio -->
                            <div class="px-4 pt-2">
                                <span class="text-md font-bold text-gray-900">ARS {{ taller.precio }}</span>
                                <span v-if="taller.precioUSD" class="text-sm text-gray-500 block">USD {{
                                    taller.precioUSD }}</span>
                            </div>

                            <!-- Botones -->
                            <div class="px-4 pb-4 mt-4">
                                <div class="flex flex-col gap-2">
                                    <!-- Botón principal: AGOTADO -->
                                    <div
                                        class="text-gray-500 text-sm font-semibold leading-none text-center py-3 px-4 rounded-lg uppercase w-full bg-gray-200 cursor-not-allowed">
                                        {{ taller.boton }}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Mobile view -->
                        <div
                            class="bg-white rounded-2xl shadow-md border border-gray-200 flex flex-row md:hidden opacity-75">
                            <!-- Imagen del taller (mobile) -->
                            <a :href="taller.linkTienda" target="_blank"
                                class="block w-1/2 aspect-square overflow-hidden rounded-l-2xl">
                                <template v-if="taller.urlAfiche">
                                    <img :src="taller.urlAfiche" :alt="taller.lema"
                                        class="w-full h-full object-cover rounded-l-2xl" @error="handleImageError" />
                                </template>
                                <div v-else
                                    class="w-full aspect-square bg-gray-100 flex items-center justify-center rounded-l-2xl">
                                    <span class="text-gray-400">Sin imagen</span>
                                </div>
                            </a>
                            <!-- Contenido del taller (mobile) -->
                            <div class="flex flex-col justify-between p-4 w-1/2">
                                <div>
                                    <!-- Fecha del taller (mobile) -->
                                    <span class="text-[10px] font-normal leading-[130%] uppercase">Desde el <span
                                            class="font-bold">{{ taller.inicio }}</span></span>
                                    <!-- Título del taller (mobile) -->
                                    <h3 class="text-base font-bold leading-[120%] text-black mt-1">
                                        {{ taller.id === 285891222 ? 'Guion cinematográfico' : taller.lema }}
                                    </h3>
                                    <!-- Docente (mobile) -->
                                    <p class="text-[10px] font-normal leading-[130%] text-gray-600 uppercase mt-1">{{
                                        taller.docente
                                        }}</p>
                                </div>
                                <div class="mt-auto">
                                    <!-- Precio ARS (mobile) -->
                                    <div class="mb-3">
                                        <span class="text-sm font-bold text-gray-900 block">ARS {{ taller.precio
                                            }}</span>
                                        <span v-if="taller.precioUSD" class="text-xs text-gray-500 block">USD {{
                                            taller.precioUSD
                                            }}</span>
                                    </div>
                                    <!-- Botón principal: AGOTADO (mobile) -->
                                    <div
                                        class="text-gray-500 text-[10px] font-semibold leading-[140%] text-center py-2 px-4 rounded-md uppercase w-full block mb-2 bg-gray-200 cursor-not-allowed">
                                        {{ taller.boton }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Talleres de Casciari 
        <div v-if="!loading && !error && casciariProducts.length > 0" class="mt-16">
            <hr class="border-t border-gray-200 mb-8">
            <h2 class="">
                <span class="text-3xl font-bold">Taller virtual con Hernán Casciari</span>
            </h2>
            <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-8 mt-8">
                <div v-for="product in casciariProducts" :key="product.id" class="post-item max-w-md w-full mx-auto">
                    <div class="bg-white rounded-2xl shadow-md border border-gray-200 flex flex-col h-full">
                        <a :href="product.onlineStoreUrl" target="_blank"
                            class="block w-full aspect-square overflow-hidden rounded-t-2xl">
                            <img v-if="product.featuredImage" :src="product.featuredImage.url" :alt="product.title"
                                class="w-full h-full object-cover rounded-t-2xl" />
                        </a>
                        <h3 class="text-lg font-bold mb-2 leading-tight text-black px-4 pt-4">{{ product.title }}</h3>
                        <div class="text-gray-700 text-base mb-2 px-4 pb-4">INSCRIPCIÓN ABIERTA</div>
                        <div class="flex items-center justify-between mb-2 mt-auto px-4 pb-4">
                            <span class="text-2xl text-gray-900">{{
                                formatPrice(product.priceRange.minVariantPrice.amount) }}</span>
                            <a :href="product.onlineStoreUrl" target="_blank"
                                class="bg-blue-600 hover:bg-blue-700 text-white font-bold py-2 px-6 rounded-lg uppercase text-base transition-colors ml-4">
                                Reservar
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        -->
    </div>
</template>

<script>
import axios from "axios";
import { useAuthStore } from "@/stores/auth";
import tiendaNubeService from "@/services/tiendanube";

export default {
    name: "ProductList",
    data() {
        return {
            talleres: [],
            loading: true,
            error: null,
            filtros: {
                mes: '',
                tipo: ''
            },
            talleresOcultos: {
                ids: [287274089],
                slugs: [
                    'once-tesis-y-antitesis-sobre-la-escritura-de-ficcion-de-guillermo-martinez'
                ]
            },
            meses: [
                'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
                'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'
            ],
            tiposDisponibles: [
                { value: 'masterclass', label: 'Masterclass' },
                { value: 'virtual', label: 'Virtual' }
            ],
            openSubMenu: null,
            sheetsConfig: {
                url: 'https://docs.google.com/spreadsheets/d/e/2PACX-1vTCo1hQ1saKKwgyEN_6E8Rv6WjxG3JJMdbFIx8JXBwC-ZlDJP0XYVozuxvwsMsEY_VVOylDMgnjvcqR/pub?gid=0&single=true&output=csv'
            }
        };
    },
    computed: {
        usuario() {
            return useAuthStore().usuario;
        },
        // Separar talleres activos de finalizados
        talleresActivos() {
            return this.talleres.filter(taller => taller.boton !== 'AGOTADO');
        },
        talleresFinalizados() {
            return this.talleres.filter(taller => taller.boton === 'AGOTADO');
        },
        // Separar campamentos y talleres virtuales de los activos
        talleresVirtualesActivos() {
            const virtuales = this.talleresActivos.filter(taller => !taller.esCampamento);
            return this.ordenarPorFechaInicio(virtuales);
        },
        campamentosActivos() {
            const campamentos = this.talleresActivos.filter(taller => taller.esCampamento);
            return this.ordenarPorFechaInicio(campamentos);
        },
        talleresActivosFiltrados() {
            return this.talleresActivos.filter(taller => {
                // Filtrar por mes
                if (this.filtros.mes) {
                    const mesBuscado = this.filtros.mes.toLowerCase();
                    // Mapa de meses a abreviaturas (añadir más si es necesario)
                    const abreviaturas = {
                        'enero': 'ene',
                        'febrero': 'feb',
                        'marzo': 'mar',
                        'abril': 'abr',
                        'mayo': 'may',
                        'junio': 'jun',
                        'julio': 'jul',
                        'agosto': 'ago',
                        'septiembre': 'sep',
                        'octubre': 'oct',
                        'noviembre': 'nov',
                        'diciembre': 'dic'
                    };
                    const abreviaturaBuscada = abreviaturas[mesBuscado];

                    // Verificar si incluye el nombre completo o la abreviatura
                    const inicioLowerCase = taller.inicio.toLowerCase();
                    return inicioLowerCase.includes(mesBuscado) || (abreviaturaBuscada && inicioLowerCase.includes(abreviaturaBuscada));
                }
                return true;
            });
        }
    },
    methods: {
        // Método para trackear clicks en botones de Reservar con Google Ads
        trackReservarClick(taller, tipo = 'taller') {
            // Verificar que gtag esté disponible
            if (typeof window !== 'undefined' && window.gtag) {
                try {
                    // Extraer precio numérico del taller
                    const precioNum = this.extractPriceNumber(taller.precio);
                    
                    // Evento personalizado de click en botón Reservar
                    // Google Ads puede capturar estos eventos para remarketing y conversiones
                    window.gtag('event', 'click_reservar', {
                        'event_category': 'Talleres',
                        'event_label': `${tipo}: ${taller.lema}`,
                        'taller_id': taller.id,
                        'taller_nombre': taller.lema,
                        'taller_tipo': tipo,
                        'taller_precio': precioNum || 0,
                        'taller_docente': taller.docente || '',
                        'currency': 'ARS',
                        'value': precioNum || 0,
                        'items': [{
                            'id': String(taller.id),
                            'name': taller.lema || 'Taller',
                            'category': tipo === 'campamento' ? 'Campamento' : 'Taller Virtual',
                            'quantity': 1,
                            'price': precioNum || 0
                        }]
                    });

                    // Si tienes un conversion_label de Google Ads, descomenta y ajusta la siguiente línea:
                    // Ejemplo: window.gtag('event', 'conversion', {
                    //     'send_to': 'AW-1255361399405005/TU_CONVERSION_LABEL_AQUI',
                    //     'value': precioNum || 0,
                    //     'currency': 'ARS',
                    //     'transaction_id': `taller-${taller.id}-${Date.now()}`
                    // });

                    console.log('📊 Google Ads: Evento de click enviado para', taller.lema, '| Tipo:', tipo, '| Precio:', precioNum);
                } catch (error) {
                    console.error('❌ Error enviando evento a Google Ads:', error);
                }
            } else {
                console.warn('⚠️ Google Ads gtag no está disponible');
            }
        },
        // Método auxiliar para extraer precio numérico
        extractPriceNumber(precioTexto) {
            if (!precioTexto) return 0;
            // Remover caracteres no numéricos excepto puntos y comas
            const precioLimpio = precioTexto.toString().replace(/[^\d.,]/g, '');
            // Reemplazar coma por punto para parseo
            const precioNormalizado = precioLimpio.replace(',', '.');
            const precioNum = parseFloat(precioNormalizado);
            return isNaN(precioNum) ? 0 : precioNum;
        },
        formatPrice(price) {
            // Convertir el precio a formato de moneda pero sin símbolo
            const numPrice = parseFloat(price.replace(/[^0-9.-]/g, ''));
            return numPrice.toLocaleString('es-AR', {
                minimumFractionDigits: 0,
                maximumFractionDigits: 0
            });
        },
        formatTitle(title) {
            const words = title.toUpperCase().split(' ');
            if (words.length > 3) {
                const firstHalf = words.slice(0, Math.ceil(words.length / 2)).join(' ');
                const secondHalf = words.slice(Math.ceil(words.length / 2)).join(' ');
                return `${firstHalf}\n${secondHalf}`;
            }
            return title.toUpperCase();
        },
        getInstructorName(product) {
            if (product.title.includes("con")) {
                const parts = product.title.split("con");
                if (parts.length > 1) {
                    return parts[1].trim().toUpperCase();
                }
            }
            return "DOLORES REYES";
        },
        getDateText(product) {
            return product.description.split("\n")[0];
        },
        getTimeText(product) {
            return "15 A 18 HS";
        },
        processProductEdges(edges) {
            const productos = edges.map((edge) => ({
                id: edge.node.id,
                title: edge.node.title,
                handle: edge.node.handle,
                onlineStoreUrl: edge.node.onlineStoreUrl || `https://tienda.orsai.org/products/${edge.node.handle}`,
                priceRange: edge.node.priceRange,
                featuredImage: edge.node.featuredImage || null,
                description: edge.node.description || "",
                totalInventory: edge.node.totalInventory || 0,
                tags: edge.node.tags || [],
            }));

            // Log de tags únicos
            const tagsUnicos = new Set();
            productos.forEach(producto => {
                producto.tags.forEach(tag => tagsUnicos.add(tag));
            });
            console.log('Tags únicos de Shopify:', Array.from(tagsUnicos));

            // Log de productos con sus tags
            console.log('Productos con sus tags:', productos.map(p => ({
                titulo: p.title,
                tags: p.tags
            })));

            return productos;
        },
        async fetchProducts() {
            try {
                console.log("Fetching products from Shopify...");
                const query = `
                    {
                        tallerCasciari: collection(handle: "taller-casciari") {
                            products(first: 250) {
                                edges {
                                    node {
                                        id
                                        title
                                        handle
                                        onlineStoreUrl
                                        priceRange {
                                            minVariantPrice {
                                                amount
                                                currencyCode
                                            }
                                        }
                                        featuredImage {
                                            url
                                            altText
                                        }
                                        description(truncateAt: 150)
                                        totalInventory
                                        tags
                                    }
                                }
                            }
                        }
                        escuelaOrsai: collection(handle: "escuela-prueba") {
                            products(first: 250) {
                                edges {
                                    node {
                                        id
                                        title
                                        handle
                                        onlineStoreUrl
                                        priceRange {
                                            minVariantPrice {
                                                amount
                                                currencyCode
                                            }
                                        }
                                        featuredImage {
                                            url
                                            altText
                                        }
                                        description(truncateAt: 150)
                                        totalInventory
                                        tags
                                    }
                                }
                            }
                        }
                    }
                `;

                const response = await axios.post(
                    "https://tienda.orsai.org/api/2023-10/graphql.json",
                    { query },
                    {
                        headers: {
                            "Content-Type": "application/json",
                            "X-Shopify-Storefront-Access-Token": "0601f486448cb11b7bb5991ac5b7e907",
                        },
                    }
                );

                console.log("Datos obtenidos de Shopify:", {
                    casciari: response.data.data.tallerCasciari?.products?.edges,
                    escuela: response.data.data.escuelaOrsai?.products?.edges
                });

                this.talleres = this.processProductEdges(
                    response.data.data.escuelaOrsai?.products?.edges || []
                );

                this.excluirTalleresOcultos();

            } catch (error) {
                console.error("Error fetching products:", error);
                this.error = "Error al cargar los productos: " + error.message;
            } finally {
                this.loading = false;
            }
        },
        toggleSubMenu(tipo) {
            if (this.openSubMenu === tipo) {
                this.openSubMenu = null;
            } else {
                this.openSubMenu = tipo;
            }
        },
        seleccionarMes(mes) {
            this.filtros.mes = mes;
            this.openSubMenu = null;
        },
        seleccionarTipo(tipo) {
            this.filtros.tipo = tipo;
            this.openSubMenu = null;
        },
        closeAllMenus() {
            this.openSubMenu = null;
        },
        limpiarFiltros() {
            this.filtros.mes = '';
            this.filtros.tipo = '';
            this.openSubMenu = null;
        },
        // Función para mapear slug a ID de inscripciones
        getInscripcionesId(slug) {
            // Mapeo de slugs a IDs numéricos para inscripciones
            const slugToIdMapping = {
                'taller-1': 1,
                'taller-2': 2,
                'taller-3': 3,
                'taller-4': 4,
                'taller-18': 18,
                // Agregar más mapeos según sea necesario
            };

            // Si el slug es un número, usarlo directamente
            if (!isNaN(slug) && slug !== '') {
                return slug;
            }

            // Si no es un número, buscar en el mapeo
            return slugToIdMapping[slug] || slug;
        },
        async fetchDataFromProductos() {
            try {
                console.log("Cargando talleres desde la API de TiendaNube...");

                // Obtener talleres desde la API de TiendaNube (con fallback automático a datos locales)
                const talleresDesdeAPI = await tiendaNubeService.getTalleresWithFallback();

                if (!talleresDesdeAPI || talleresDesdeAPI.length === 0) {
                    throw new Error("No se pudieron obtener talleres desde TiendaNube");
                }

                // Mantener compatibilidad con el componente
                this.talleres = talleresDesdeAPI.map(taller => ({
                    ...taller,
                    botonInfo: taller.botonInfo || null,
                    linkTienda: taller.linkTienda || `https://talleres.orsai.org/products/${taller.slug}`
                }));

                this.excluirTalleresOcultos();

                console.log('Talleres cargados desde API de TiendaNube:', this.talleres.length);
            } catch (error) {
                console.error("Error obteniendo talleres desde API de TiendaNube:", error);
                this.error = "Error al cargar los talleres: " + error.message;

                // Fallback: intentar cargar desde Google Sheets si falla todo
                console.log("Intentando fallback a Google Sheets...");
                await this.fetchDataFromSheets();
            } finally {
                this.loading = false;
            }
        },

        async fetchDataFromSheets() {
            try {
                const response = await axios.get(this.sheetsConfig.url);
                // Usar papaparse para parsear el CSV correctamente
                const Papa = (await import('papaparse')).default;
                const parsed = Papa.parse(response.data, { header: true, skipEmptyLines: true });
                this.talleres = parsed.data
                    .map((row, idx) => {
                        // Aseguramos que el ID sea un número válido (mantener para compatibilidad)
                        const idNum = Number((row.ID || '').toString().trim());
                        // Usar la nueva columna SLUG para el identificador
                        const slug = (row.SLUG || '').toString().trim();
                        let urlAfiche = (row.URL_AFICHE || '').trim().replace(/^"(.*)"$/, '$1');
                        try {
                            if (urlAfiche) new URL(urlAfiche);
                        } catch {
                            urlAfiche = '';
                        }
                        return {
                            id: idNum, // Mantener ID para compatibilidad
                            slug: slug, // Nueva propiedad slug
                            docente: row.DOCENTE || '',
                            lema: row.LEMA || '',
                            inicio: row.INICIO || '',
                            precio: this.formatPrice(row.ARS || '0'),
                            precioUSD: row.USD || '',
                            linkTienda: row.LINK_TIENDA || '',
                            urlAfiche,
                            boton: row.BOTON || 'Reservar',
                            botonInfo: row.BOTON_INFO,
                            colorBoton: row.COLOR_BOTON
                        };
                    })
                    .filter(taller => !isNaN(taller.id) && taller.slug) // Filtrar por ID válido y slug presente
                    .sort((a, b) => a.id - b.id);
                console.log('Talleres cargados desde Google Sheets:', this.talleres);
                // Log adicional para verificar la estructura de los datos
                console.log('Estructura de talleres con slug:', this.talleres.map(t => ({
                    id: t.id,
                    slug: t.slug,
                    docente: t.docente,
                    lema: t.lema,
                    botonInfo: t.botonInfo
                })));

                this.excluirTalleresOcultos();
            } catch (error) {
                console.error("Error fetching data from Google Sheets:", error);
                this.error = "Error al cargar los talleres: " + error.message;
            } finally {
                this.loading = false;
            }
        },
        handleImageError(e) {
            if (!e.target) return;

            console.warn('Error cargando imagen:', e.target.src);

            // Crear el elemento de fallback
            const fallback = document.createElement('div');
            fallback.className = 'w-full aspect-square bg-gray-100 flex items-center justify-center rounded-t-2xl';
            fallback.innerHTML = '<span class="text-gray-400">Imagen no disponible</span>';

            // Reemplazar la imagen con el fallback
            if (e.target.parentNode) {
                e.target.parentNode.replaceChild(fallback, e.target);
            }
        },
        excluirTalleresOcultos() {
            const { ids, slugs } = this.talleresOcultos;
            const totalAntes = this.talleres.length;
            
            this.talleres = this.talleres.filter(taller => {
                // Comparar ID (puede ser número o string)
                const coincideId = ids.some(idOculto => {
                    // Normalizar comparación: convertir ambos a número si es posible
                    const idTaller = typeof taller.id === 'number' ? taller.id : parseInt(taller.id);
                    const idOcultoNum = typeof idOculto === 'number' ? idOculto : parseInt(idOculto);
                    return idTaller === idOcultoNum || String(taller.id) === String(idOculto);
                });
                
                // Comparar slug (normalizar para comparación case-insensitive)
                const coincideSlug = slugs.some(slugOculto => {
                    const slugTaller = (taller.slug || '').toLowerCase().trim();
                    const slugOcultoNorm = (slugOculto || '').toLowerCase().trim();
                    return slugTaller === slugOcultoNorm;
                });
                
                // Log si se excluye un taller
                if (coincideId || coincideSlug) {
                    console.log(`🚫 Taller excluido: "${taller.lema}" (ID: ${taller.id}, Slug: ${taller.slug})`, {
                        coincideId,
                        coincideSlug,
                        idsOcultos: ids,
                        slugsOcultos: slugs
                    });
                }
                
                return !coincideId && !coincideSlug;
            });
            
            const totalDespues = this.talleres.length;
            const excluidos = totalAntes - totalDespues;
            
            if (excluidos > 0) {
                console.log(`✅ Exclusión completada: ${excluidos} taller(es) excluido(s) de ${totalAntes} total(es)`);
            }
        },
        // Función para parsear fechas de inicio y ordenar inteligentemente
        parsearFechaInicio(fechaTexto) {
            if (!fechaTexto) return new Date('2099-12-31'); // Fechas sin texto van al final

            const fechaTextoLower = fechaTexto.toLowerCase();
            const mesActual = new Date().getMonth() + 1; // 1-12
            const añoActual = new Date().getFullYear();

            // Mapeo de meses en español
            const meses = {
                'enero': 1, 'febrero': 2, 'marzo': 3, 'abril': 4, 'mayo': 5, 'junio': 6,
                'julio': 7, 'agosto': 8, 'septiembre': 9, 'octubre': 10, 'noviembre': 11, 'diciembre': 12,
                'ene': 1, 'feb': 2, 'mar': 3, 'abr': 4, 'may': 5, 'jun': 6,
                'jul': 7, 'ago': 8, 'sep': 9, 'oct': 10, 'nov': 11, 'dic': 12
            };

            // Buscar mes en el texto
            let mesEncontrado = null;
            let añoEncontrado = añoActual;

            for (const [nombreMes, numeroMes] of Object.entries(meses)) {
                if (fechaTextoLower.includes(nombreMes)) {
                    mesEncontrado = numeroMes;
                    break;
                }
            }

            // Buscar año en el texto (4 dígitos)
            const añoMatch = fechaTexto.match(/\b(20\d{2})\b/);
            if (añoMatch) {
                añoEncontrado = parseInt(añoMatch[1]);
            } else {
                // Si no hay año específico, determinar si es este año o el próximo
                if (mesEncontrado && mesEncontrado < mesActual) {
                    añoEncontrado = añoActual + 1;
                }
            }

            // Buscar día en el texto
            const diaMatch = fechaTexto.match(/\b(\d{1,2})\b/);
            const dia = diaMatch ? parseInt(diaMatch[1]) : 1;

            if (mesEncontrado) {
                return new Date(añoEncontrado, mesEncontrado - 1, dia);
            }

            return new Date('2099-12-31'); // Fechas no parseables van al final
        },
        // Función para ordenar talleres por fecha de inicio (del más próximo al más lejano)
        ordenarPorFechaInicio(talleres) {
            return [...talleres].sort((a, b) => {
                const fechaA = this.parsearFechaInicio(a.inicio);
                const fechaB = this.parsearFechaInicio(b.inicio);
                return fechaA - fechaB; // Del más cercano al más lejano
            });
        }
    },
    async mounted() {
        await this.fetchDataFromProductos();
    },
};
</script>

<style scoped>
.product-title {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
}
</style>

<script setup>
// Helper para cupo máximo
const getCupoMaximo = (product) => product.cupoMaximo || 100;
</script>